import { formatJSON } from './index'

const DEFAULT_SCENES = { top: true, combo: true, confirm: true }

export function getSmartRecommendConfig(storeInfo) {
    const open = !!storeInfo?.isOpenSmartRecommend
    const ext = formatJSON(storeInfo?.extendColumn1) || {}
    const rec = (ext.smartRecommend && typeof ext.smartRecommend === 'object')
        ? ext.smartRecommend
        : DEFAULT_SCENES

    return {
        open,
        top: open && !!rec.top,
        combo: open && !!rec.combo,
        confirm: open && !!rec.confirm,
    }
}
